import { defineElementNoInputs } from './define-element-no-inputs';
import { IgnoreInputsNotBeenSetBeforeRenderWarningSymbol } from './definition-options';
export function defineElement() {
    return (initInput) => {
        return defineElementNoInputs({
            ...initInput,
            options: {
                [IgnoreInputsNotBeenSetBeforeRenderWarningSymbol]: false,
            },
            ...initInput.options,
        });
    };
}
